/**
 * Builds a `?key=value` query string, skipping empty values and expanding arrays into repeated
 * params (`?courseIds=a&courseIds=b`) — the shape ASP.NET Core binds a `List<T>` from.
 *
 * Shared rather than per-module: the analytics filter bar is multi-select on six dimensions, and a
 * builder that stringified an array would send `courseIds=a,b` as one value, which binds to nothing
 * and silently drops the filter.
 */
export function buildQueryString<T extends object>(params?: T): string {
  if (!params) return "";

  const search = new URLSearchParams();

  for (const [key, value] of Object.entries(params as Record<string, unknown>)) {
    if (value === undefined || value === null || value === "") continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item === undefined || item === null || item === "") continue;
        search.append(key, String(item));
      }
      continue;
    }

    search.append(key, String(value));
  }

  const qs = search.toString();
  return qs ? `?${qs}` : "";
}
